export const envTest = false; //change to true to use baseUrlTest
const baseUrlTest = "http://192.168.15.30:45456";
const baseUrl = "https://api.portalsoftcase.com.br/appviamais";
export const urlApi = envTest ? baseUrlTest :  baseUrl

// Add proxy configuration for development environments
export const isDevelopment = process.env.NODE_ENV === 'development';
export const useProxy = isDevelopment && typeof window !== 'undefined';
export const getApiUrl = (endpoint) => {
  if (useProxy) {
    // Use a proxy URL for development to bypass CORS
    return `/api-proxy${endpoint}`;
  }
  return `${urlApi}${endpoint}`;
};

export const timeoutBig = 30000 //30s
export const timeoutStandart = 10000 //10s
export const timeoutSmall = 5000 //5s

export const timeoutIntegration = 10000 //10s

